import { localizeBilledUpon, localizePricingType, localizeRecurrence } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/services-localize';
import { summarizeDecimalRange } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/summarizeDecimalRange';
import { nameSegment } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/summarizeServicePredicate';
const SET_LOCALIZERS = {
    billedUpon: localizeBilledUpon,
    recurrence: localizeRecurrence,
    pricingType: localizePricingType
};
const includedValues = (set)=>{
    var _ref, _set_in;
    var _set_nin;
    if (set == null || ((_ref = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return null;
    return (_set_in = set.in) !== null && _set_in !== void 0 ? _set_in : [];
};
const setHasValues = (set)=>{
    var _ref, _ref1;
    var _set_in, _set_nin;
    return set != null && (((_ref = (_set_in = set.in) === null || _set_in === void 0 ? void 0 : _set_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0);
};
export const presentConditionKeys = (predicate)=>{
    const keys = [];
    if (nameSegment(predicate.name) != null) keys.push('name');
    if (setHasValues(predicate.billedUpon)) keys.push('billedUpon');
    if (setHasValues(predicate.recurrence)) keys.push('recurrence');
    if (setHasValues(predicate.pricingType)) keys.push('pricingType');
    if (predicate.priceMin != null) keys.push('priceMin');
    if (predicate.priceMax != null) keys.push('priceMax');
    if (predicate.cap != null) keys.push('cap');
    if (predicate.discount != null) keys.push('discount');
    if (predicate.priceIncrease != null) keys.push('priceIncrease');
    if (predicate.limitedTimeDiscountOffer != null) keys.push('limitedTimeDiscountOffer');
    return keys;
};
const discountTypeAdjective = (value, t)=>{
    switch(value){
        case 'percent':
            return t.servicesDiscountTypePercent();
        case 'value':
            return t.servicesDiscountTypeValue();
        default:
            return value;
    }
};
const discountNoun = (discount, t)=>{
    var _ref;
    var _discount_type;
    const types = (_ref = (_discount_type = discount.type) === null || _discount_type === void 0 ? void 0 : _discount_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.length === 0) return t.servicesDiscountNoun();
    const adjectives = types.map((value)=>discountTypeAdjective(value, t)).join(" ".concat(t.orConnector(), " "));
    return "".concat(adjectives, " ").concat(t.servicesDiscountNoun());
};
const isBareCapExistence = (cap)=>cap.gt === '0' && cap.gte == null && cap.lt == null && cap.lte == null && cap.eq == null && cap.neq == null;
const capNoun = (cap, t)=>{
    const bound = isBareCapExistence(cap) ? '' : summarizeDecimalRange(cap);
    return bound === '' ? t.servicesCapNoun() : "".concat(t.servicesCapNoun(), " ").concat(bound);
};
const annualPriceIncreaseNoun = (t)=>t.servicesPriceIncreaseAnnualNoun();
const singleFieldAlternatives = (predicate, key, t)=>{
    var _predicate_limitedTimeDiscountOffer;
    if (key === 'billedUpon' || key === 'recurrence' || key === 'pricingType') {
        const values = includedValues(predicate[key]);
        if (values == null || values.length === 0) return null;
        const localize = SET_LOCALIZERS[key];
        return {
            labels: values.map((value)=>localize(t, value)),
            isHas: false
        };
    }
    if (key === 'cap' && predicate.cap != null) {
        return {
            labels: [
                capNoun(predicate.cap, t)
            ],
            isHas: true
        };
    }
    const priceIncrease = predicate.priceIncrease;
    if (key === 'priceIncrease' && priceIncrease != null && priceIncrease.percent == null) {
        var _ref;
        var _startOnType_in;
        const startOnType = priceIncrease.startOnType;
        if (startOnType != null && ((_ref = (_startOnType_in = startOnType.in) === null || _startOnType_in === void 0 ? void 0 : _startOnType_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0) {
            return {
                labels: [
                    annualPriceIncreaseNoun(t)
                ],
                isHas: true
            };
        }
        if (priceIncrease.exists === true) {
            return {
                labels: [
                    t.servicesPriceIncreaseNoun()
                ],
                isHas: true
            };
        }
    }
    if (key === 'discount' && predicate.discount != null && predicate.discount.amount == null) {
        return {
            labels: [
                discountNoun(predicate.discount, t)
            ],
            isHas: true
        };
    }
    if (key === 'limitedTimeDiscountOffer' && ((_predicate_limitedTimeDiscountOffer = predicate.limitedTimeDiscountOffer) === null || _predicate_limitedTimeDiscountOffer === void 0 ? void 0 : _predicate_limitedTimeDiscountOffer.exists) === true) {
        return {
            labels: [
                t.servicesConditionalDiscountNoun()
            ],
            isHas: true
        };
    }
    return null;
};
const armAlternatives = (arm, t)=>{
    var _ref;
    var _arm_or;
    if (arm.not != null || ((_ref = (_arm_or = arm.or) === null || _arm_or === void 0 ? void 0 : _arm_or.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return null;
    const keys = presentConditionKeys(arm);
    if (keys.length !== 1) return null;
    return singleFieldAlternatives(arm, keys[0], t);
};
export const serviceAlternatives = (predicate, t)=>{
    var _predicate_or;
    if (predicate.not != null) return null;
    const keys = presentConditionKeys(predicate);
    const orArms = (_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : [];
    if (orArms.length > 0) {
        if (keys.length > 0) return null;
        const arms = orArms.map((arm)=>armAlternatives(arm, t));
        const present = arms.filter((arm)=>arm != null);
        if (present.length !== arms.length) return null;
        const labels = present.flatMap((arm)=>arm.labels);
        const allHas = present.every((arm)=>arm.isHas);
        const noneHas = present.every((arm)=>!arm.isHas);
        if (!allHas && !noneHas) return null;
        return {
            labels,
            isHas: allHas
        };
    }
    if (keys.length !== 1) return null;
    return singleFieldAlternatives(predicate, keys[0], t);
};
